import { useEffect } from "react";
import { useSelector } from "react-redux";

import { ComponentMyStateLeaderBoardPage } from "@components";
import { selectAuth } from "@redux";
import { campaignAPI } from "@api";

export const PageMyStateLeaderBoardPage = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentMyStateLeaderBoardPage
            memberTier={memberTier}
            avatar={""}
            fullName={""}
            socials={[]}
        />
    );
};
